import { render, staticRenderFns } from "./InfoBar.vue?vue&type=template&id=1d8420e0&scoped=true&"
import script from "./InfoBar.vue?vue&type=script&lang=js&"
export * from "./InfoBar.vue?vue&type=script&lang=js&"
import style0 from "./InfoBar.vue?vue&type=style&index=0&id=1d8420e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8420e0",
  null
  
)

export default component.exports